import Vue from 'vue'
import { Pagination, Carousel, CarouselItem } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import store from "@/store";
// 第一步 引入 vue-router 这个依赖
import VueRouter from 'vue-router'
import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'

Vue.use(vueMiniPlayer)
Vue.component(Pagination.name, Pagination)
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.config.productionTip = false

const originalPush = VueRouter.prototype.push

// 配置路由重复点击
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if(onReject || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(error => error)
}

const router = new VueRouter({
  mode:'hash',//默认的是 hash 模式 在我们的路由前面 加一个 /#/ // history 模式 是没有一个#
  routes:[
    {
      path: '/', // 域名 http://localhost:8080/
      component:() => import('./pages/HomePage.vue')
    },
    {
      path: '/about',  //  this.$route.push(`/about/${id}`)
      component:() => {
        return import('./pages/AboutPage.vue')
      }
    },
    {
      path: '/news/:columnType/:id',
      component: () => import('./pages/NewList')
    },
    {
      path: '/search',
      component: () => import('./pages/SearchResult')
    }
  ]
})
// 第二个 通过use方法 在vue当中 注册 vuerouter中间件

Vue.use(VueRouter)//使用我们 vue-router 中间件

new Vue({
  //在vue实例当中 注册 我们路由相关的数据信息
  router,// new Vue 注册 router
  render: h => h(App),
  store
}).$mount('#app')
